<template>
  <ListItemsWithTableLayout>
    <template #body>
      <HandlerAccessDenied :is-denied="isDenied">
        <OrganizationFilterForm
          :isFilterEnabled="isFilterEnabled"
          @toggle-filter="isFilterEnabled = !isFilterEnabled"
          @set-filter="setFilter"
        ></OrganizationFilterForm>
        <TopListOrganizationsPanel
          @set-common-filter="setCommonFilter"
          @toggle-filter="isFilterEnabled = !isFilterEnabled"
          :isFilterEnabled="isFilterEnabled"
          :isFilterSetted="isFilterSetted"
        ></TopListOrganizationsPanel>
        <div
          id="table-container"
          class="table-container flex flex-col"
          :class="[
            filteredOrganizations && filteredOrganizations.length == 0
              ? 'empty'
              : 'filled',
          ]"
        >
          <OrganizationsTable
            :organizations="filteredOrganizations"
            :isActiveFirst="activeFirstFromStore"
            :isLoading="isLoading"
            :rowsCount="rowsCount(46, 20) * tableDisplaySettings.first"
            @sort-table="sortTable"
            @update-table="updateOrganizationsList"
          ></OrganizationsTable>
          <EmptyTableMessage
            v-if="
              filteredOrganizations &&
              filteredOrganizations.length == 0 &&
              !isLoading
            "
          >
            <template #text>
              Примените другой фильтр или создайте первую организацию. <br />
              Для этого кликните на кнопку "Создать организацию".
            </template>
          </EmptyTableMessage>
        </div>
        <Paginator
          v-model:first="tableDisplaySettings.first"
          @update:first="updateOrganizationsList"
          :rows="1"
          class="s-paginator"
          :totalRecords="store.organizationsPagesCount"
          template="PrevPageLink CurrentPageReport NextPageLink"
          currentPageReportTemplate="{first} из {totalRecords}"
        />
      </HandlerAccessDenied>
    </template>
  </ListItemsWithTableLayout>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from "vue";

import Paginator from "primevue/paginator";
import ListItemsWithTableLayout from "@/widgets/layouts/ListItemsWithTableLayout.vue";
import TopListOrganizationsPanel from "@/entities/dictionaries/organizations/panels/TopListOrganizationsPanel.vue";
import OrganizationsTable from "@/entities/dictionaries/organizations/OrganizationsTable.vue";
import OrganizationFilterForm from "@/entities/dictionaries/organizations/forms/OrganizationFilterForm.vue";
import EmptyTableMessage from "@/entities/segments/EmptyTableMessage.vue";
import HandlerAccessDenied from "@/shared/base/HandlerAccessDenied.vue";

import {
  useOrganizationsStore,
  OrganizationParams,
} from "@/store/dictionaries/organizations";
import { useAuthStore } from "@/store/auth/login";
import { rowsCount } from "@/services/utils/Pagination";
import {
  setOrganizationsParamsByFilter,
  FilterForm,
} from "@/services/dictionaries/organizations";

const store = useOrganizationsStore();
const authStore = useAuthStore();
const isLoading = ref(false);
const isFilterEnabled = ref(false);
const isFilterSetted = ref(false);
const tableDisplaySettings = ref({
  first: 0,
  orderField: "",
  commonFilter: "",
  filter: {} as FilterForm,
});

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(
    ["system:read", "system:edit"],
    ["organization:read", "organization:edit"],
    ["dictionaries:read", "dictionaries:edit"]
  );
});

const filteredOrganizations = computed(() => {
  return store.organizationsList;
});

const activeFirstFromStore = computed(() => store.activeFirst);

onMounted(() => {
  loadData();
});

const loadData = () => {
  isLoading.value = true;
  updateOrganizationsList();
};

const setCommonFilter = (filter: string) => {
  tableDisplaySettings.value.commonFilter = filter;
  updateOrganizationsList();
};

const sortTable = (order_by: string) => {
  tableDisplaySettings.value.orderField = order_by;
  updateOrganizationsList();
};

const setFilter = (filter: FilterForm, isSetted: boolean) => {
  tableDisplaySettings.value.filter = filter;
  isFilterSetted.value = isSetted;
  updateOrganizationsList();
};

const updateOrganizationsList = () => {
  let isEnded = false;
  setTimeout(() => {
    if (!isEnded) {
      isLoading.value = true;
    }
  }, 200);
  const params: OrganizationParams = {
    page: tableDisplaySettings.value.first + 1,
    per_page: rowsCount(46, 20),
  };

  setOrganizationsParamsByFilter(params, tableDisplaySettings.value);

  store.getOrganizations(params).finally(() => {
    isLoading.value = false;
    isEnded = true;
  });
};

let resizeTimeout: number;

window.addEventListener("resize", function () {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(updateOrganizationsList, 200);
});
</script>
